import { __assign } from "tslib";
import LAYOUTS from '../../common/constants/layout';
import PLACEMENTS from '../../common/constants/placements';
import SCROLL_DIRECTION from '../../common/constants/scrollDirection';
import { calcTargetItemSize } from '../helpers/layoutHelper';
import { assignByString } from '../helpers/optionsUtils';
var fixToFullsize = function (options) {
    var presetOptions = __assign({}, options);
    presetOptions.galleryLayout = LAYOUTS.FULLSIZE;
    presetOptions.cubeImages = true;
    presetOptions = assignByString(presetOptions, 'layoutParams_cropRatio', '100%/100%');
    presetOptions.cubeType = 'fill';
    presetOptions.titlePlacement = PLACEMENTS.SHOW_ON_HOVER;
    presetOptions.scrollDirection = SCROLL_DIRECTION.HORIZONTAL;
    presetOptions.galleryMargin = 0;
    presetOptions.isVertical = false;
    presetOptions.groupSize = 1;
    presetOptions.groupTypes = '1';
    presetOptions.numberOfImagesPerCol = 1;
    presetOptions.smartCrop = false;
    presetOptions.galleryType = 'Strips';
    presetOptions.hasThumbnails = false;
    presetOptions.enableScroll = true;
    presetOptions.scrollSnap = true;
    presetOptions.cropOnlyFill = false;
    presetOptions.scatter = 0;
    presetOptions.rotatingScatter = '';
    presetOptions.imageMargin = 0;
    return presetOptions;
};
export var fixedOptions = fixToFullsize({});
export var createOptions = function (options) {
    var res = __assign({}, options);
    res = fixToFullsize(res);
    res.targetItemSize = calcTargetItemSize(res);
    return res;
};
//# sourceMappingURL=fullsizeGallery.js.map